export default {
  pageSize: state => state.pageSize,
  searchTerm: state => state.searchTerm,
  filterOptions: state => state.filterOptions,
  filterBy: state => state.filterBy,
  sortDir: state => state.sortDir,
  orderBy: state => state.orderBy,
  testdrives: state => state.testdrives,
  testdrive: state => state.testdrive,
  testdrivedrives: state => state.testdrivedrives,
  testdrivedrive: state => state.testdrivedrive,
  highlightSave: state => state.highlightSave,
  isTestDriveChecked: state => state.isTestDriveChecked,
  testdrivewaypoints: state => state.testdrivewaypoints,
  testdrivewaypoint: state => state.testdrivewaypoint,
  weather: state => state.weather,
  videolink: state => state.videolink,
  testdriveTypeRates: state => state.testdriveTypeRates,
  testdriveResults: state => state.testdriveResults,
  reportPreference: state => state.reportPreference,
  models: state => state.models
}



// WEBPACK FOOTER //
// ./src/store/modules/testdrives/getters.js